/**
 * Wishlist hearts, header count and the wishlist page.
 * Signed-in lists live in the account (REST tc/v1/wishlist); guest lists live in
 * this browser and are merged into the account at sign-in. A guest's existing
 * WPC Smart Wishlist list is imported once on first visit.
 */
const W = (window.TC && window.TC.wishlist) || null;
const KEY = 'tc_wishlist';
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

let ids = [];

const readLocal = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
const writeLocal = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage off */ } };

async function api(body) {
  const res = await fetch(W.rest, {
    method: body ? 'POST' : 'GET',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': W.nonce },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(String(res.status));
  return (await res.json()).ids || [];
}

function render() {
  const set = new Set(ids.map(Number));
  $$('[data-wish]').forEach((b) => {
    const on = set.has(Number(b.dataset.wish));
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', String(on));
    b.setAttribute('aria-label', on ? W.i18n.remove : W.i18n.add);
  });
  $$('[data-wish-count]').forEach((el) => { el.textContent = ids.length ? String(ids.length) : ''; });
}

async function toggle(btn) {
  const id = Number(btn.dataset.wish);
  const on = !ids.map(Number).includes(id);
  ids = on ? [id, ...ids.filter((x) => Number(x) !== id)] : ids.filter((x) => Number(x) !== id);
  render();
  btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
  if (W.loggedIn) {
    try { ids = await api({ id, on }); render(); } catch (e) { /* keep optimistic state; next load re-syncs */ }
  } else {
    writeLocal(ids);
  }
  // On the wishlist page, removing a heart removes the card.
  if (!on && btn.closest('[data-wishlist-items]')) {
    btn.closest('li')?.remove();
    const page = document.querySelector('[data-wishlist-page]');
    if (page && !page.querySelector('[data-wishlist-items] li')) page.querySelector('[data-wishlist-empty]').hidden = false;
  }
}

async function renderGuestPage() {
  const page = document.querySelector('[data-wishlist-page]');
  if (!page || W.loggedIn || !ids.length) return;
  const url = new URL(W.rest + '/cards');
  url.searchParams.set('ids', ids.join(','));
  const data = await fetch(url, { credentials: 'same-origin' }).then((r) => r.json());
  if (data.html) {
    page.querySelector('[data-wishlist-items]').innerHTML = data.html;
    page.querySelector('[data-wishlist-empty]').hidden = true;
    render();
  }
}

async function init() {
  if (!W) return;
  if (W.loggedIn) {
    ids = W.ids || [];
    const local = readLocal();
    if (local.length) {
      try { ids = await api({ merge: local }); writeLocal([]); } catch (e) { /* retry next load */ }
    }
  } else {
    ids = readLocal();
    if (!ids.length && W.wpc) {
      try {
        const res = await fetch(W.rest + '/import', { credentials: 'same-origin' }).then((r) => r.json());
        if (res.ids && res.ids.length) { ids = res.ids; writeLocal(ids); }
      } catch (e) { /* nothing to import */ }
    }
  }
  render();
  renderGuestPage();

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b);
  });

  // Hearts added later (filtered results, load more) pick up their state.
  let raf = 0;
  new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(render); })
    .observe(document.body, { childList: true, subtree: true });
}

init();
